import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-step-progress',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslatePipe],
  templateUrl: './step-progress.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './step-progress.component.scss',
})
export class StepProgressComponent {
  @Input()
  steps: string[] = []

  @Input()
  currentStep: number = 1

  @Input()
  completedSteps: number = 0

  @Input()
  disabled: boolean = false

  @Output()
  stepClick = new EventEmitter<number>()

  onStepClick(stepIndex: number) {
    if (!this.disabled && stepIndex + 1 <= this.currentStep) {
      this.stepClick.emit(stepIndex)
    }
  }

  isCompleted(stepIndex: number): boolean {
    return !this.disabled && stepIndex + 1 <= this.completedSteps
  }

  isCurrent(stepIndex: number): boolean {
    if (this.disabled) {
      return stepIndex === 0
    }
    if (this.isCompleted(stepIndex)) {
      return false
    }
    return stepIndex + 1 === this.currentStep
  }

  isUpcoming(stepIndex: number): boolean {
    if (this.disabled) {
      return stepIndex > 0
    }
    return stepIndex + 1 > this.currentStep
  }

  isClickable(stepIndex: number): boolean {
    return !this.disabled && stepIndex + 1 <= this.currentStep
  }

  isStepDisabled(stepIndex: number): boolean {
    return this.disabled || stepIndex + 1 > this.currentStep
  }

  isConnectorCompleted(stepIndex: number): boolean {
    return !this.disabled && stepIndex + 1 < this.currentStep
  }

  isConnectorPartial(stepIndex: number): boolean {
    return !this.disabled && stepIndex + 1 === this.currentStep
  }
}
